import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullname',
})
export class FullnamePipe implements PipeTransform {
  transform(value: any, args?: any): string {
    if (!value) {
      return '';
    }
    const valueAsUser = value;
    const fullname =
      value.firstName || value.lastName
        ? [value.firstName, value.lastName].join(' ')
        : valueAsUser.username ||
          (value.emails && value.emails[0] ? value.emails[0].email : '');

    return valueAsUser.fullName ? valueAsUser.fullName : fullname;
  }
}
